var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6558 1.78009C15.2449 1.3788 15.2449 0.709979 15.6558 0.308687C16.0565 -0.102896 16.7242 -0.102896 17.1248 0.308687L23.6995 6.88371C24.1001 7.29529 24.1001 7.95382 23.6995 8.36541L17.1248 14.9404C16.7242 15.352 16.0565 15.352 15.6558 14.9404C15.2449 14.5391 15.2449 13.8703 15.6558 13.469L20.443 8.67409H1.03755C0.462271 8.67409 -7.62939e-06 8.20077 -7.62939e-06 7.62456C-7.62939e-06 7.04834 0.462271 6.57502 1.03755 6.57502H20.443L15.6558 1.78009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.a87f0740af46b060e8bcb583416ff989.svg";
export { ForwardRef as ReactComponent };